function formatPrice (price, onlyDigitValues) {
  if ((price === '0.00' || price === 0) && !onlyDigitValues) {
    return 'Free'
  } else {
    return (
      '$' +
      Number(price)
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    )
  }
}

export default formatPrice
